module.exports = "@media print {\n  body {\n    visibility: hidden; }\n  .verticalcenter {\n    visibility: visible; }\n  .verticalcenter {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0; }\n  .hideprint {\n    display: none; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/comprobante/pedido-generado.component.scss
// module id = ./src/app/shared/components/comprobante/pedido-generado.component.scss
// module chunks = main